// Global Types
import type {
  $Children,
  $Component,
} from 'common.types';
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';

// Helpers
import {
  animationClass,
} from '@vroskus/library-helpers/dist/browser';

// Types
type $OptionalProps = {
  children?: $Children;
  closeAction?: (arg0: () => void) => void;
};

type $Props = $OptionalProps & $Translate & {
  content: $Component<unknown> | string;
  title: string;
};

type $State = {
  visible: boolean;
};

class CommonDialogView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    children: undefined,
    closeAction: undefined,
  };

  constructor(props: $Props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  componentDidMount(): void {
    const {
      closeAction,
    } = this.props;

    if (closeAction) {
      closeAction(() => {
        this.toggle();
      });
    }
  }

  toggle(): void {
    this.setState((prevState: $State) => ({
      visible: !prevState.visible,
    }));
  }

  childrenWithToggleHandler(): $Component<unknown> | null {
    const {
      children,
    } = this.props;

    if (children && React.isValidElement(children)) {
      return React.cloneElement(
        children,
        {
          // @ts-expect-error dialog
          onClick: () => this.toggle(),
        },
      );
    }

    return null;
  }

  render() {
    const {
      content,
      t,
      title,
    } = this.props;
    const {
      visible,
    } = this.state;

    return (
      <>
        {this.childrenWithToggleHandler()}
        <div className={`modal bg-gray-300 bg-opacity-50 ${visible ? 'active' : ''} ${animationClass('fadeIn')}`}>
          <div className={'modal-dialog modal-dialog_centered max-w-sm mx-auto'}>
            <div className={'modal-content'}>
              <div className={'modal-header'}>
                <h3 className={'h3'}>
                  {title}
                </h3>
                <button
                  className={'close la la-times'}
                  onClick={() => this.toggle()}
                  type={'button'}
                />
              </div>
              <div className={'modal-body'}>
                {content}
              </div>
              <div className={'modal-footer flex justify-end'}>
                <button
                  className={'btn btn_secondary btn_outlined uppercase'}
                  onClick={() => this.toggle()}
                  type={'button'}
                >
                  {t('Close')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default CommonDialogView;
